import { render } from "./ExpandableImage.vue?vue&type=template&id=1bccb6dc"
import script from "./ExpandableImage.vue?vue&type=script&lang=js"
export * from "./ExpandableImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__